import React from 'react'
import styled from '@emotion/styled'
import { colors, font, radius, spacing } from '@mobi/component-library/Theme/Common'
import { Icon } from '@mobi/component-library/Common/V2'
import type { ShareBetData } from '@core/Areas/ShareBet/types'
import { ExpertHubButton } from './Components/ExpertHubButton'

export const ShareOptions: React.FC<{
  handleShareWithExternalClick(): void
  data: ShareBetData
  dismissTray(): void
}> = ({ handleShareWithExternalClick, data, dismissTray }) => {
  return (
    <WrapperStyled>
      <button onClick={handleShareWithExternalClick} type='button'>
        <span>
          <Icon name='LineShare02' />
        </span>
        Share via...
      </button>

      <ExpertHubButton data={data} dismissTray={dismissTray} />
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'minmax(0, 1fr)',
  gap: spacing.smx1,

  button: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    height: '10rem',
    padding: spacing.sm,
    backgroundColor: colors.white,
    border: '0.1rem solid ' + colors.neutral[200],
    borderRadius: radius.lgx1,
    color: colors.neutral[900],
    fontFamily: font.family.primary,
    fontWeight: font.weight.medium,
    fontSize: font.size.lg.fontSize,
    letterSpacing: font.size.lg.letterSpacing,
    lineHeight: font.size.lg.lineHeight,
    WebkitTapHighlightColor: 'transparent',
    transition: 'color 0.15s ease-out, background-color 0.15s ease-out',

    '@media (hover: hover) and (pointer: fine)': {
      ':hover': { backgroundColor: colors.neutral[100] },
    },

    ':active': {
      color: `color(from ${colors.black} srgb r g b / 0.5)`,
      backgroundColor: colors.neutral[300],
    },

    '> span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '3.6rem',
      height: '3.6rem',
      borderRadius: radius.full,
      backgroundColor: colors.lavender[100],
    },
  },
})
